import {
  _formatArray,
  formatImageUrlByDevice,
  appendHttpsToUrl,
  BuildServerlessBookCoverImageUrl,
  renderFreeVoiceBanner,
  formatPrice,
} from "../../helpers/Helper";
import Device from "../../constants/Device";
import IMAGESIZES from "../../constants/IMAGESIZES";
import NextImage from "@components/Image/NextImage";

import { useAppContext } from "@components/Provider";
import AffiliateButton from "@components/AffiliateButton/AffiliateButton";
import Content from "@components/Content/Content";
import SubHeader from "@components/SubHeader/SubHeader";
import PostImage from "@components/PostImage/PostImage";

import styles from "./BookListicle.module.css";
import "./BookListicle.css";

const BookListicle = (props) => {
  const {
    description = { props: { value: "" } },
    affiliate = {
      props: {
        buttonType: "",
        urlType: "",
        buttonText: "",
        linkUrl: { url: "", title: "" },
        title: "",
        amazonLink: "",
        itunesLink: "",
        bnLink: "",
        image: "",
        price: "",
        dlp: "",
      },
    },
    subHeader = { props: { value: "" } },
    salePrice = "",
  } = props;
  const { isMobile } = useAppContext();
  const renderTitle = () => {
    return (
      <h3 className={styles["afb__title"]}>
        <span dangerouslySetInnerHTML={{ __html: affiliate.props.title }} />
      </h3>
    );
  };

  const renderAuthor = () => {
    let { author, authors } = affiliate.props,
      _author;

    const authorNames = (names) => {
      const displayName =
        typeof names === "object" ? names.display_name : names;
      return (
        <>
          {displayName ? (
            <p className={styles["afb__author"]}>
              <span>By</span> {displayName}
            </p>
          ) : (
            ""
          )}
        </>
      );
    };

    if (author) {
      let _authorName = author;
      if (typeof author === "string") {
        _authorName = [author];
      }
      const arr = _formatArray(_authorName, ", ", " and ");
      _author = authorNames(arr);
    } else if (authors) {
      let _authorNames = [];
      authors.forEach((author) => {
        if (
          (author?.role && author?.role === 1) ||
          (author?.Role && author?.Role === 1)
        ) {
          _authorNames.push(author?.Display_Name || author?.display_name);
        } else if (typeof author === "string") {
          _authorNames.push(author); //there might be some books whose authors will be string type
        }
      });
      const arr = _formatArray(_authorNames, ", ", " and ");
      _author = authorNames(arr);
    }
    return _author;
  };

  const getSalePriceValue = () => {
    if (
      salePrice !== null &&
      typeof salePrice == "object" &&
      salePrice.hasOwnProperty("props")
    ) {
      return salePrice.props.value;
    }
    return formatPrice(salePrice);
  };

  const renderSalePrice = () => {
    const salePrice = getSalePriceValue();
    let origPrice = "";
    if (affiliate.props.urlType == "External Link") {
      origPrice = affiliate.props.dlp && affiliate.props.dlp !== ""
        ? formatPrice(affiliate.props.dlp)
        : "";
    } else {
      origPrice = affiliate.props.price && affiliate.props.price !== ""
        ? formatPrice(affiliate.props.price)
        : "";
    }
    if (salePrice) {
      let salePriceText =
        salePrice === "0.00" ? (
          <div className={[styles["sale"], "sale"].join(" ")}>FREE</div>
        ) : (
          <div className={[styles["sale"], "sale"].join(" ")}>
            <p>On Sale $</p>
            <span>
              <p>
                {formatPrice(salePrice)}
              </p>
            </span>
          </div>
        );

      let origPriceText = origPrice && origPrice !== "" ? (
        <del className="dlp">
          ${origPrice}
        </del>
      ) : null;

      return (
        <div className="sale_price">
          {salePriceText}
          {origPriceText}
        </div>
      );
    }
  };

  const renderKindleUnlimitedBanner = () => {
    return (
      <div>
        {props?.affiliate?.props?.isPromotedToKindleDeals && (
          <NextImage
            ImageUrl={`${process.env.S3_IMAGE_URL}/Kindle_Unlimited-Tag.png`}
            style={{ objectFit: "contain", marginTop: "10px" }}
            width={286}
            height={32}
            isLazyload={true}
          />
        )}
      </div>
    );
  };

  const renderAtlText = (propsData) =>
    propsData.props?.image?.props?.image?.Alt_Text || propsData.props.title;

  const renderBookCover = () => {
    const { buttonType, urlType, image, title } = affiliate.props;
    let bookCoverUrl;
    // url buttons don't have book covers
    if (buttonType == "Url (link)") {
      return null;
    }

    switch (urlType) {
      case "Internal Link":
        bookCoverUrl = BuildServerlessBookCoverImageUrl(
          IMAGESIZES.BC_LISTICLE,
          image?.props?.image?.Name ?? null
        );
        break;
      case "External Link":
        //As external link are uploaded to orion-upload, there are three copies like sm, md, lg. So in either case it is book image and no need to render md_ image. So making following change to render sm_ image always
        //formatImageUrlByDevice(image.props.image.Name, props.imageSize)
        bookCoverUrl =
          image?.props?.image && image?.props?.image?.Name
            ? formatImageUrlByDevice(
                image.props.image.Name,
                Device.PHONE,
                Device.PHONE
              )
            : image && typeof image === "string" // Check if image is a string because when title is from books collection then it will be string type
              ? BuildServerlessBookCoverImageUrl(IMAGESIZES.BC_LISTICLE, image)
              : null;
        break;
      default:
        bookCoverUrl = null;
        break;
    }
    if (bookCoverUrl) {
      const searchRegExp = /\s/gi;
      const replaceWith = "-";

      const bookImage = (
        <PostImage
          ImageUrl={appendHttpsToUrl(bookCoverUrl)}
          Alt_Text={renderAtlText(affiliate)}
          Title={
            image?.props?.image?.Title ||
            title.replace(searchRegExp, replaceWith)
          }
          style={{ maxWidth: "100%" }}
          height={salePrice?.props?.value !== "" && isMobile ? "150" : "320"}
          width="210"
        />
      );
      return (
        <div
          className={[styles["afb__book-cover"], "afb__book-cover"].join(" ")}
        >
          {bookImage}
          {props.freevoice && renderFreeVoiceBanner(210, 60)}
        </div>
      );
    }
  };

  const renderComponent = () => {
    /**
     * HTML structure is changed as book listcile design changes on mobile and desktop.
     */
    return (
      <>
        <div
          className={styles["book-listicle"]}
          style={{
            "--book-listicle-image-margin":
              salePrice?.props?.value !== "" ? "0px" : "10px auto",
            scrollMarginTop: "100px",
            scrollBehavior: "smooth"
          }}
          id={`${props.type}-${props.index}`}
        >
          {subHeader.props.value !== "" ? (
            <SubHeader {...subHeader.props} />
          ) : (
            ""
          )}
          {salePrice?.props?.value !== "" && isMobile ? (
            <>
              <div
                className={[
                  styles["afb__description"],
                  "afb__description",
                  "twoColumn",
                ].join(" ")}
              >
                {renderBookCover()}
                {renderTitle()}
                {renderAuthor()}
                {renderKindleUnlimitedBanner()}
                {renderSalePrice()}
                <Content {...description.props} />
                <AffiliateButton
                  currentSiteID={props.currentSiteID}
                  bookListicle={true}
                  className="bookListicleAf"
                  {...affiliate.props}
                  postType={props.postType}
                  salePrice={getSalePriceValue()}
                  freevoice={props.freevoice}
                />
              </div>
            </>
          ) : (
            <>
              <div className={styles["info"]}>
                <div className={styles["image"]}>{renderBookCover()}</div>
                <div
                  className={[
                    styles["afb__description"],
                    "afb__description",
                  ].join(" ")}
                >
                  {renderTitle()}
                  {renderAuthor()}
                  {renderKindleUnlimitedBanner()}
                  {renderSalePrice()}
                  <Content {...description.props} />
                  <AffiliateButton
                    currentSiteID={props.currentSiteID}
                    bookListicle={true}
                    className="bookListicleAf"
                    {...affiliate.props}
                    postType={props.postType}
                    salePrice={getSalePriceValue()}
                    freevoice={props.freevoice}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  };
  return <>{renderComponent()}</>;
};

export default BookListicle;
